// QR Kiosk v2 — skeleton shimmer primitive.
// Ported from designer kiosk2-states.jsx `Sk`. The `.kv2-sk` shimmer class lives
// in kiosk-v2-tokens.css (§5.5, reduced-motion safe). Page-level 1:1 skeleton
// compositions are per-phase (KV2-1+); KV2-0 ships only this primitive.
import React from "react";

export interface SkeletonBlockProps {
  w?: number | string;
  h?: number | string;
  r?: number;
  style?: React.CSSProperties;
}

export function SkeletonBlock({ w, h = 12, r = 6, style }: SkeletonBlockProps) {
  return (
    <span
      className="kv2-sk"
      style={{ display: "block", width: w, height: h, borderRadius: r, ...style }}
    />
  );
}

export default SkeletonBlock;
